import * as Types from '../../../../../api/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type SetGuestMutationVariables = Types.Exact<{
  data: Types.GuestInput;
}>;


export type SetGuestMutation = { __typename?: 'Mutation', SetGuest?: { __typename?: 'Visitor', _id: string, name?: string | null, email?: string | null, image?: string | null } | null };


export const SetGuestDocument = gql`
    mutation SetGuest($data: GuestInput!) {
  SetGuest(data: $data) {
    _id
    name
    email
    image
  }
}
    `;
export type SetGuestMutationFn = ApolloReactCommon.MutationFunction<SetGuestMutation, SetGuestMutationVariables>;

/**
 * __useSetGuestMutation__
 *
 * To run a mutation, you first call `useSetGuestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetGuestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setGuestMutation, { data, loading, error }] = useSetGuestMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSetGuestMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetGuestMutation, SetGuestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetGuestMutation, SetGuestMutationVariables>(SetGuestDocument, options);
      }
export type SetGuestMutationHookResult = ReturnType<typeof useSetGuestMutation>;
export type SetGuestMutationResult = ApolloReactCommon.MutationResult<SetGuestMutation>;
export type SetGuestMutationOptions = ApolloReactCommon.BaseMutationOptions<SetGuestMutation, SetGuestMutationVariables>;